import { useCallback } from 'react';
import { formatGraphqlErrors } from 'utils/helpers';
import { useMutation } from '@apollo/client/react';
import {
  type SetPlanCategoryQuoteMutationVariables,
  SetPlanCategoryQuoteDocument,
  ProjectPlanDocument,
} from 'graphql/generated/graphql';

const useSetPlanCategoryQuote = (): [
  (variables: SetPlanCategoryQuoteMutationVariables) => Promise<void>,
  boolean,
] => {
  const [setPlanCategoryQuoteMutation, { loading }] = useMutation(SetPlanCategoryQuoteDocument);

  const planCategoryQuote = useCallback(
    async ({ projectId, categoryName, value }: SetPlanCategoryQuoteMutationVariables) => {
      try {
        await setPlanCategoryQuoteMutation({
          variables: { projectId, categoryName, value },
          refetchQueries: [{ query: ProjectPlanDocument, variables: { projectId } }],
          awaitRefetchQueries: true,
        });
      } catch (error) {
        const e = formatGraphqlErrors(error);
        throw e;
      }
    },
    [setPlanCategoryQuoteMutation],
  );
  return [planCategoryQuote, loading];
};

export default useSetPlanCategoryQuote;
